import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "checkbox"]

  connect() {
    this.checkboxTarget.addEventListener("change", this.submitForm.bind(this))
  }

  async submitForm() {
    if (this.checkboxTarget.dataset.alert) {
      const confirmController = this.application.getControllerForElementAndIdentifier(
        document.querySelector('[data-controller~="confirm"]'),
        'confirm',
      )
      confirmController.button.textContent = this.checkboxTarget.dataset.confirmButton || confirmController.buttonValue
      const confirmed = await confirmController.request({ message: this.checkboxTarget.dataset.alert })
      if (confirmed) {
        this.formTarget.requestSubmit();
      } else {
        this.checkboxTarget.checked = !this.checkboxTarget.checked;
      }
    } else {
      this.formTarget.requestSubmit();
    }
  }
}
